import { render, staticRenderFns } from "./Locationform.vue?vue&type=template&id=95e78262&"
import script from "./Locationform.vue?vue&type=script&lang=js&"
export * from "./Locationform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports